<template>
	<div class="newsItemHome">
        <div class="image bg-cover" :style="{'background-image':'url('+item.image+')'}">
			<template v-if="item.type == 'video'">
				<span class="shadow"></span>
				<img class="play-btn" src="~@assets/img/play-white-small.png" alt="播放按钮">
			</template>
			<span v-if="item.duration" class="duration">{{item.duration}}</span>
			<span class="ring absolute"></span>
		</div>
		<p class="title font-20 line-clamp-2">{{item.title}}</p>
		<p class="time">{{item.time}}</p>
    </div>
</template>

<script>
	import Vue from 'vue'
	export default {
		data() {
			return {
				askData:{},
			}
		},
		props:['item'],
		methods: {
		}
	}
</script>

<style lang="scss">
	.newsItemHome{
		display: inline-block;
		vertical-align: top;
		width: 23.5%;
		margin-left: 2%;
		cursor: pointer;
		&:nth-child(4n+1){
			margin-left: 0;
		}
		.image{
			position: relative;
			padding-bottom: 64.39%;
			background-color: #f4f4f4;
			&::after{
				content: '';
				position: absolute;
				background: #3ED8C4;
				height: 3px;
				left: 0;
				bottom: 0;
				width: 100%;
				opacity: 0.5;
				transition: transform .3s,opacity 0.6s;
				transform: scaleX(0);
				transform-origin: 100% 0;
			}
			.duration{
				position: absolute;
				bottom: 12px;
				right: 12px;
				width: 46px;
				line-height: 24px;
				border-radius: 6px;
				color: #ffffff;
				background: rgba($color: #000000, $alpha: 0.6);
				font-size: 14px;
				text-align: center;
			}
		}
		&:hover .image::after{
			opacity: 1;
			transform: scaleX(1);
			transform-origin: 0 0;
		}
		.title{
			line-height: 1.4;
			margin-top: 16px;
			margin-bottom: 10px;
		}
		.time{
			color: #666;
		}
		.shadow{
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: rgba($color: #000000, $alpha: 0.4);
			opacity: 0;
			transition: all 0.2s;
		}
		&:hover .shadow{
			opacity: 1;
		}
		.play-btn{
			opacity: 0;
			width: 82px;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
			transform: scale(1.3);
			transition: all 0.3s;
		}
		&:hover .play-btn{
			opacity: 1;
			transform: scale(1);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/newsItemHome.vue